import functions from "./functions";

const profile = {
  path: "/dashboard", // path for router
  uniqueId: "/dashboard", // uniqueId for caching and other purposes
  template: "DashboardTemplate", // template name, must be located in index of folder template/index
  title: "service.title", // title of the page
  props: {
    onPageInit: functions.onPageInit,
    cancelLink: {
      shown: true,
      label: "button.cancel",
      onClick: functions.onCancel,
    },
    submitButton: {
      disabled: functions.isSubmitButtonDisabled,
      shown: true,
      label: "button.next",
      arrowShown: true,
      onClick: functions.onSubmit,
    },
  },
};

export default profile;
